"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Box = _interopRequireDefault(require("../../Containers/Box"));
var _CardLink = _interopRequireDefault(require("./common/CardLink"));
var _HeaderButton = _interopRequireDefault(require("./common/HeaderButton"));
var _Popover = _interopRequireDefault(require("../../Tooltips/Popover"));
var _helpers = require("../../helpers");
var _excluded = ["userName", "userInitials", "automationHook", "userItems"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** User menu items */
  userItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    action: _propTypes["default"].func
  })),
  /** User name text */
  userName: _propTypes["default"].string,
  /** User initials */
  userInitials: _propTypes["default"].string.isRequired,
  /**Hook used for automation testing. For  HeaderIconButton the suffix 'icon-button' is added*/
  automationHook: _propTypes["default"].string
};
var User = function User(_ref) {
  var userName = _ref.userName,
    userInitials = _ref.userInitials,
    automationHook = _ref.automationHook,
    userItems = _ref.userItems,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], _extends({
    w: "200px",
    cardProps: {
      p: "base"
    },
    triggerW: "auto",
    align: "end",
    automationHook: automationHook,
    renderTrigger: function renderTrigger(_ref2) {
      var togglePopover = _ref2.togglePopover,
        isOpen = _ref2.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_HeaderButton["default"], _extends({
        triggerText: userName,
        isOpen: isOpen,
        onClick: togglePopover,
        w: "auto",
        maxW: "200px",
        userInitials: userInitials
      }, other));
    }
  }, other), function () {
    return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
      d: "flex",
      gap: "base",
      direction: "column",
      alignItems: "flex-start"
    }, userItems.map(function (userItem) {
      return /*#__PURE__*/_react["default"].createElement(_CardLink["default"], {
        key: userItem.label,
        hoverColor: "text",
        onClick: userItem.action,
        automationHook: (0, _automationHooks.getHook)(automationHook, "button_".concat((0, _helpers.labelKebab)(userItem.label)))
      }, userItem.label);
    }));
  });
};
User.propTypes = propTypes;
var _default = User;
exports["default"] = _default;